import { Drawer } from '@material-ui/core';
import * as React from 'react';
import { DataGroup } from '../../../../components/data-group/DataGroup';
import { DataGroupPoint } from '../../../../components/data-group/DataGroupPoint';
import { TextArea } from '../../../../components/form-elements/TextArea';
import { TimeZoneAbbreviations } from '../../../../components/utility/timezones';
import { FlyoutSaveCancel } from '../../../../components/flyout-components/FlyoutSaveCancel';
import { StatusCode } from '../../../../utils/api';
import { AppUtils } from '../../../../utils/app-utils';
import { toLongDateTimeNoSeconds } from '../../../../utils/date-utils';
import { ShipmentType } from '../../../models/enums/shipment-type';
import { BackhaulShipmentAction } from '../../../models/shipments/shipment-action';
import { TransportationSvc } from '../../../service';

interface IProps {
    visible         : boolean;
    onClose         : any;
    onSuccess       : any;
    truckId         : number;
    truckVersion    : string;
    stop            : BackhaulShipmentAction|undefined;
    entityType      : ShipmentType;
}

export const ActionEditBackhaul = (props: IProps) => {
    
    const [service]                             = React.useState(new TransportationSvc());
    const [editStop, setEditStop]               = React.useState<BackhaulShipmentAction>(new BackhaulShipmentAction());

    /**
     * Hydrate the required properties for editing
     */
    React.useEffect(() => {
        if (props.visible && props.stop) {            
            const tmpStop = {...props.stop};
            // tmpStop.isFixedFreight = tmpStop.fixedFreightAmount ? true : false;
            setEditStop(tmpStop);
        }
    }, [props.visible]);

    /**
     * Close handler for the flyout
     */
    const onClose = () => {
        setEditStop({} as unknown as BackhaulShipmentAction);
        props.onClose();
    };

    /**
     * Save the schedule back to the server, and if successful
     * close the flyout
     */
    const onSave = async () => {
        
        console.log('aweaf');
        const result = await service.updateStop(
            editStop,
            props.truckId,
            props.truckVersion,
            props.entityType
        );

        if (result.status === StatusCode.Success) {
            setEditStop({} as unknown as BackhaulShipmentAction);
            props.onSuccess();
        }
    };

    const onNoteChange = (e : any) => {
        const t = {...editStop };
        t.note = e.target.value;
        setEditStop(t);
    };

    return <Drawer 
                anchor="right" 
                onClose={ onClose }
                open={ props.visible }>
                {
                    !AppUtils.IsEmpty(editStop)
                        ? <div className="stop-action-drawer mini">

                            <div className="row">
                                <div className="col-md-12">                        
                                    <h1>Edit Backhaul</h1>
                                </div>
                            </div>

                            <div className="row divider-row">
                                <div className="col-12">
                                    
                                    <DataGroup title="">

                                        <DataGroupPoint
                                            label="Vendor"
                                            value={ editStop.vendorName }
                                        />

                                        <DataGroupPoint
                                            label="Address"
                                            value=""
                                            contentValue={`${ editStop.address.addressLine1 } ${ editStop.address.city }, ${ editStop.address.stateProvince } ${editStop.address.postalCode}` }
                                        />

                                        <DataGroupPoint
                                            label="Stop Time"
                                            value={
                                                editStop.actionTime
                                                    ? `${ toLongDateTimeNoSeconds(editStop.actionTime.local) } ${ TimeZoneAbbreviations[editStop.actionTime.timeZone] }` 
                                                    : 'Not Set'
                                            } 
                                        />

                                    </DataGroup>

                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <TextArea
                                        id="backhaul-note"
                                        label="Note"
                                        onChange={ onNoteChange }
                                        defaultLines={ 3 }
                                        value={ editStop.note }
                                    />
                                </div>
                            </div>

                            <FlyoutSaveCancel
                                onSave={ onSave }
                                onCancel={ props.onClose }
                            />      
                        </div>
                        : null
                }    
        </Drawer>;
};
